<template>
  <div class="app-router">
    <h2 class="font-weight-bold pb-5">
      <v-row>
        <v-col cols="8">Riwayat Nego Produk</v-col>
        <v-col cols="4 text-right d-none">
          <v-btn outlined class="text-subtitle-2 text-capitalize">
            <v-icon center class="mr-2">mdi-download</v-icon>Unduh Laporan Penjualan
          </v-btn>
        </v-col>
      </v-row>
    </h2>
 
    <v-card outlined class="px-3 py-3"> 
      <v-tabs grow show-arrows v-model="intabs">
        <v-tab class="text-caption font-weight-bold">Semua</v-tab> 
        <v-tab class="text-caption font-weight-bold">Diajukan</v-tab> 
        <v-tab class="text-caption font-weight-bold">Disetujui</v-tab> 
        <v-tab class="text-caption font-weight-bold">Ditolak</v-tab> 
        <!-- <v-tab class="text-caption font-weight-bold d-none">Bayar di Toko</v-tab> -->
       
 
        <v-tab-item>
          <pesananData :allowedStatus="[]" v-if="intabs === 0"></pesananData>
        </v-tab-item>
        <v-tab-item>
          <pesananData :allowedStatus="['submitted']" v-if="intabs === 1"></pesananData>
        </v-tab-item>
        <v-tab-item>
          <pesananData :allowedStatus="['approved']" v-if="intabs === 2"></pesananData>
        </v-tab-item>
        <v-tab-item>
          <pesananData :allowedStatus="['rejected']" v-if="intabs === 3"></pesananData>
        </v-tab-item>

        <!-- <template v-for="(status, idlist) in filterStatus(statusVerifikasi)">
          <v-tab-item :key="idlist">
            <pesananData :allowedStatus="[status.trx_status]" v-if="intabs === (idlist + 1)"></pesananData>
          </v-tab-item>
        </template> -->
      </v-tabs>
    </v-card>

    <v-dialog v-model="dialogWaitPaymentList" persistent max-width="900">
      <v-card>
        <v-card-title
          class="d-flex flex-column align-start text-left text-h6 text-capitalize black--text darken-4"
        >
          Menunggu Pembayaran
          <div
            class="d-block text-caption grey--text"
          >Pelanggan belum melakukan pembayaran atas item ini.</div>
        </v-card-title>
        <v-card-text class="pt-2 pb-0 px-5">
          <pesananBaruData :allowedStatus="['created']" v-if="dialogWaitPaymentList"></pesananBaruData>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr />
            <v-btn
              outlined
              @click="dialogWaitPaymentList = false"
              class="my-2 px-5 text-capitalize"
            >Tutup</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import pesananData from "./components/pesananData";  

export default {
  components: {
    pesananData,  
  },
  data() {
    return {
      intabs: null,
      status: [],
      allowedStatus: [
        "pending",
        "approved",
        'rejected'
      ],
      dialogWaitPaymentList: false,
      unpaid: 0,
      paymentFilter: {
        value: "payment_store",
        comparison: "=",
        type: "string",
        field: "trx_payment_method",
      },
      statusFilter: {
        value: "",
        comparison: "yes",
        type: "list",
        field: "trx_status",
      },
      negoFilter: [
        {
          value: "1",
          comparison: "=",
          type: "string",
          field: "trx_is_nego",
        },
        {
          value: "1",
          comparison: "=",
          type: "string",
          field: "trx_status_nego",
        },
      ],
      countNego : 0
    };
  },
  computed: {
    ...mapState("transaksiSeller", ["statusVerifikasi"])
  },
  methods: {
    ...mapActions("transaksiSeller", ["getStatusPesanan"]),

    statusCaption(status) {
      let listStatus = {
        'pending' : 'Menunggu Verifikasi',
        'approved' : 'Pembayaran Disetujui',
        'rejected' : 'Pembayaran Ditolak'
      } 
      if (listStatus[status]) return listStatus[status];
    },

    filterStatus(data) {
      if (data) {
        let showStatus = data.filter(d =>
          this.allowedStatus.includes(d.trx_status)
        );
        return showStatus;
      }
    },
    getUnpaid() {
      const unpaidqty = this.statusVerifikasi.filter(d =>
        ["created"].includes(d.trx_status)
      );
      if (this.statusVerifikasi) this.unpaid = unpaidqty[0].count_status;
      else this.unpaid = 0;
    },
    async getCountListPesanan() { 
      console.log('count');
      this.loadingList = await true;
      let params = await [];
      let status = "";
      let allowedStatus = ['created']
      for (let i = 0; i < allowedStatus.length; i++) {
        status +=
          i < allowedStatus.length - 1
            ? allowedStatus[i] + "::"
            : allowedStatus[i];
      }
      this.statusFilter.value = await status;
      if (this.statusFilter.value) params.push(this.statusFilter);
 
      params.push(...this.negoFilter);

      this.page = await 1;
      await this.$store.dispatch("transaksiSeller/getPesananCount",
        this.queryString({
          limit: 1,
          page: 1,
          params: params,
        })
      )
        .then(async (res) => { 
          this.countNego = res.pagination.total_data
          // this.listPesanan = await this.pesananData;
          this.loadingList = false;
        })
        .catch(() => {
          this.loadingList = true;
        });
    },
  },
  async created() {
    // this.getCountListPesanan()
    this.$store.dispatch("setPageTitle", `Pesanan Saya`);
    // await this.getStatusPesanan();
    this.getUnpaid();
  },
  mounted() {
    let tab = this.$route.query.type;
    if (tab == "waiting") this.dialogWaitPaymentList = true;
    if (tab == "new") this.intabs = 2;
    if (tab == "ready") this.intabs = 3;
    if (tab == "pengiriman") this.intabs = 4;
    if (tab == "selesai") this.intabs = 5;
  }
};
</script>